import definitions from "./definitions";
import operators from "./operators";

/*
category: friendlyName of table
table: actual table name
fullTableName: incase if i need to send this when switching between modes to prepopulate the fields
column: actually name of column used for fields with no filters
friendlyName: used for fields and filters
translation: translates the filter into plain english
queryBuilderJSON: filter rules
distinctValueJSON: this will fire 
*/
const version = "1.0";
const globalLimit = 1000;
const db = "IUSM-CARDIO";
const dbType = "Snowflake";
const patientTableName = "CV.PATIENT_SUMMARY";
const patientKey = 'CV.PATIENT_SUMMARY.PATIENT_KEY';

const data = {
  version,
  globalLimit,
  db,
  patientTableName,
  getDistinctCptCodes: (phrase = null) => {
    return {
      dbType,
      referenceTable: true,
      autoComplete: phrase ? true : false,
      autoCompletePhrase: phrase,
      limit: globalLimit,
      name: "getDistinctColumnValues",
      columnNames: [
        {
          columnName: "CV.CPT.CPT_CODE",
        },
        {
          columnName: "CV.CPT.CPT_DESCRIPTION",
        },
      ],
    };
  },
  getDistinctIcd9Codes: (phrase = null) => {
    return {
      dbType,
      referenceTable: true,
      autoComplete: phrase ? true : false,
      autoCompletePhrase: phrase,
      limit: globalLimit,
      name: "getDistinctColumnValues",
      columnNames: [
        {
          columnName: "CV.ICD9.CODE",
        },
        {
          columnName: "CV.ICD9.SHORT_DESCRIPTION",
        },
        {
          columnName: "CV.ICD9.DESCRIPTION",
        },
      ],
    };
  },
  getDistinctIcd10Codes: (phrase = null) => {
    return {
      dbType,
      referenceTable: true,
      autoComplete: phrase ? true : false,
      autoCompletePhrase: phrase,
      limit: globalLimit,
      name: "getDistinctColumnValues",
      columnNames: [
        {
          columnName: "CV.ICD10.ICD_10_CODE",
        },
        {
          columnName: "CV.ICD10.SHORT_DESCRIPTION",
        },
        {
          columnName: "CV.ICD10.LONG_DESCRIPTION",
        },
      ],
    };
  },
  queryItems: [
    {
      category: "Allergy History",
      icon: "TriangleAlert",
      table: "ALLERGY",
      fullTableName: "CV.ALLERGY_HISTORY",
      friendlyName: "Allergy",
      key: "ALLERGY_KEY",
      column: "CV.ALLERGY_HISTORY.ALLERGY_DESCRIPTION",
      operator: "=",
      enableTooltip: true,
      tooltip: {
        definition: definitions.allergy.definition,
        example: definitions.allergy.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "CV.ALLERGY_HISTORY.ALLERGY_DESCRIPTION";
          },
          friendlyName: "Allergy",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "CV.ALLERGY_HISTORY.ALLERGY_DESCRIPTION",
                },
                // {
                //   columnName: "DH_CRC.CRC_CV_D_ALLERGY.ALLERGY_KEY",
                // }
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Allergy History",
          table: "ALLERGY HISTORY",
          fullTableName: "CV.ALLERGY_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Reaction",
          key: "REACTION",
          column: "CV.ALLERGY_HISTORY.REACTION",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.64453024205661451",
              field: (props) => {
                return "CV.ALLERGY_HISTORY.REACTION";
              },
              friendlyName: "Reaction",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.ALLERGY_HISTORY.REACTION",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.ALLERGY_HISTORY.ALLERGY_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
      ],
    },
    {
      category: "Patient Demographics",
      icon: "User",
      table: "PATIENT",
      fullTableName: "CV.PATIENT",
      friendlyName: "Patient Gender",
      key: "GENDER",
      column: "CV.PATIENT_SUMMARY.GENDER",
      dataType: "TEXT",
      operator: "=",
      enableTooltip: true,
      tooltip: {
        definition: definitions.patientDemographics.definition,
        example: definitions.patientDemographics.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "CV.PATIENT_SUMMARY.GENDER";
          },
          friendlyName: "Patient Gender",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "CV.PATIENT_SUMMARY.GENDER",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Patient Demographics",
          table: "PATIENT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
          parentTable: "PATIENT",
          friendlyName: "Birth Year",
          key: "BIRTH_YEAR",
          column: "CV.PATIENT_SUMMARY.BIRTH_YEAR",
          not: false,
          dataType: "DATE",
          operator: "=",
          isChildFilterNumeric: true,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.PATIENT_SUMMARY.BIRTH_YEAR";
              },
              friendlyName: "Patient Age",
              operators: operators.number,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.PATIENT_SUMMARY.BIRTH_YEAR",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.PATIENT_SUMMARY.GENDER",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">=",
              operatorLabel: "greater than or equal to",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Patient Demographics",
          table: "PATIENT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
          parentTable: "PATIENT",
          friendlyName: "Patient Age",
          key: "AGE",
          column: "CV.PATIENT_SUMMARY.AGE",
          not: false,
          dataType: "NUMBER",
          operator: "=",
          isChildFilterNumeric: true,
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.PATIENT_SUMMARY.AGE";
              },
              friendlyName: "Patient Age",
              operators: operators.number,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.PATIENT_SUMMARY.AGE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.PATIENT_SUMMARY.GENDER",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">=",
              operatorLabel: "greater than or equal to",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "NUMBER",
            },
          ],
        },
        // {
        //   category: "Patient Demographics",
        //   table: "PATIENT",
        //   fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
        //   parentTable: "PATIENT",
        //   friendlyName: "Marital Status",
        //   key: "MARITAL_STATUS",
        //   column: "CV.PATIENT_SUMMARY.MARITAL_STATUS",
        //   not: false,
        //   dataType: "TEXT",
        //   operator: "=",
        //   queryBuilderJSON: [
        //     {
        //       id: "r-0.6445302420566821",
        //       field: (props) => {
        //         return "CV.PATIENT_SUMMARY.MARITAL_STATUS";
        //       },
        //       friendlyName: "Marital Status",
        //       operators: operators.text,
        //       distinctValueJSON: (columnValue, phrase = null) => {
        //         return {
        //           dbType,
        //           autoComplete: phrase ? true : false,
        //           autoCompletePhrase: phrase,
        //           limit: globalLimit,
        //           name: "getDistinctColumnValues",
        //           columnNames: [
        //             {
        //               columnName: "CV.PATIENT_SUMMARY.MARITAL_STATUS",
        //             }
        //           ],
        //           wheres: {
        //             id: "g-0.8517528779532519",
        //             rules: [
        //               {
        //                 id: "r-0.6445302420566821",
        //                 field:
        //                   "CV.PATIENT_SUMMARY.GENDER",
        //                 operator: "=",
        //                 valueSource: "value",
        //                 value: columnValue,
        //                 dataType: "TEXT",
        //               },
        //             ],
        //             combinator: "and",
        //             not: false,
        //           },
        //         };
        //       },
        //       showOperator: true,
        //       operator: "=",
        //       operatorLabel: "is",
        //       valueSource: "value",
        //       value: null,
        //       any: false,
        //       dataType: "TEXT"
        //     },
        //   ],
        // },
        {
          category: "Patient Demographics",
          table: "PATIENT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
          parentTable: "PATIENT",
          friendlyName: "State",
          key: "STATE_CODE",
          column: "CV.PATIENT_SUMMARY.STATE_CODE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.PATIENT_SUMMARY.STATE_CODE";
              },
              friendlyName: "State",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.PATIENT_SUMMARY.STATE_CODE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.PATIENT_SUMMARY.GENDER",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Patient Demographics",
          table: "PATIENT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
          parentTable: "PATIENT",
          friendlyName: "ADI Score",
          key: "ADI_SCORE",
          column: "CV.PATIENT_SUMMARY.ADI_SCORE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.PATIENT_SUMMARY.ADI_SCORE";
              },
              friendlyName: "ADI Score",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.PATIENT_SUMMARY.ADI_SCORE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.PATIENT_SUMMARY.GENDER",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Patient Demographics",
          table: "PATIENT",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
          parentTable: "PATIENT",
          friendlyName: "Race",
          key: "RACE",
          column: "CV.PATIENT_SUMMARY.RACE_DESCRIPTION",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.PATIENT_SUMMARY.RACE_DESCRIPTION";
              },
              friendlyName: "Race",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.PATIENT_SUMMARY.RACE_DESCRIPTION",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.PATIENT_SUMMARY.GENDER",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        // {
        //   category: "Patient Demographics",
        //   table: "PATIENT",
        //   fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
        //   parentTable: "PATIENT",
        //   friendlyName: "Ethnicity",
        //   key: "ETHNICITY",
        //   column: "CV.PATIENT_SUMMARY.RACE_DESCRIPTION",
        //   not: false,
        //   dataType: "TEXT",
        //   operator: "=",
        //   queryBuilderJSON: [
        //     {
        //       id: "r-0.6445302420566821",
        //       field: (props) => {
        //         return "CV.PATIENT_SUMMARY.RACE_DESCRIPTION";
        //       },
        //       friendlyName: "Ethnicity",
        //       operators: operators.text,
        //       distinctValueJSON: (columnValue, phrase = null) => {
        //         return {
        //           dbType,
        //           autoComplete: phrase ? true : false,
        //           autoCompletePhrase: phrase,
        //           limit: globalLimit,
        //           name: "getDistinctColumnValues",
        //           columnNames: [
        //             {
        //               columnName: "CV.PATIENT_SUMMARY.RACE_DESCRIPTION",
        //             }
        //           ],
        //           wheres: {
        //             id: "g-0.8517528779532519",
        //             rules: [
        //               {
        //                 id: "r-0.6445302420566821",
        //                 field:
        //                   "CV.PATIENT_SUMMARY.GENDER",
        //                 operator: "=",
        //                 valueSource: "value",
        //                 value: columnValue,
        //                 dataType: "TEXT",
        //               },
        //             ],
        //             combinator: "and",
        //             not: false,
        //           },
        //         };
        //       },
        //       showOperator: true,
        //       operator: "=",
        //       operatorLabel: "is",
        //       valueSource: "value",
        //       value: null,
        //       any: false,
        //       dataType: "TEXT"
        //     },
        //   ],
        // },
        // {
        //   category: "Patient Demographics",
        //   table: "PATIENT",
        //   fullTableName: "DH_CRC_IUMED.IUMED_DBO_PATIENT",
        //   parentTable: "PATIENT",
        //   friendlyName: "Patient Type",
        //   key: "PATIENT_TYPE",
        //   column: "CV.PATIENT_SUMMARY.PATIENT_TYPE",
        //   not: false,
        //   dataType: "TEXT",
        //   operator: "=",
        //   queryBuilderJSON: [
        //     {
        //       id: "r-0.6445302420566821",
        //       field: (props) => {
        //         return "CV.PATIENT_SUMMARY.PATIENT_TYPE";
        //       },
        //       friendlyName: "Patient Type",
        //       operators: operators.text,
        //       distinctValueJSON: (columnValue, phrase = null) => {
        //         return {
        //           dbType,
        //           autoComplete: phrase ? true : false,
        //           autoCompletePhrase: phrase,
        //           limit: globalLimit,
        //           name: "getDistinctColumnValues",
        //           columnNames: [
        //             {
        //               columnName: "CV.PATIENT_SUMMARY.PATIENT_TYPE",
        //             }
        //           ],
        //           wheres: {
        //             id: "g-0.8517528779532519",
        //             rules: [
        //               {
        //                 id: "r-0.6445302420566821",
        //                 field:
        //                   "CV.PATIENT_SUMMARY.GENDER",
        //                 operator: "=",
        //                 valueSource: "value",
        //                 value: columnValue,
        //                 dataType: "TEXT",
        //               },
        //             ],
        //             combinator: "and",
        //             not: false,
        //           },
        //         };
        //       },
        //       showOperator: true,
        //       operator: "=",
        //       operatorLabel: "is",
        //       valueSource: "value",
        //       value: null,
        //       any: false,
        //       dataType: "TEXT"
        //     },
        //   ],
        // },
      ],
    },
    {
      category: "Ejection Fraction",
      icon: "Heart",
      table: "EJECTION_FRACTION",
      fullTableName: "CV.EJECTION_FRACTION",
      friendlyName: "Ejection Fraction",
      key: "DISPLAY_NAME",
      column: "CV.EJECTION_FRACTION.DISPLAY_NAME",
      operator: "=",
      enableTooltip: true,
      tooltip: {
        definition: definitions.ejectionFraction.definition,
        example: definitions.ejectionFraction.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "CV.EJECTION_FRACTION.DISPLAY_NAME";
          },
          friendlyName: "Mode",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "CV.EJECTION_FRACTION.DISPLAY_NAME",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Ejection Fraction",
          table: "EJECTION_FRACTION",
          fullTableName: "CV.EJECTION_FRACTION",
          friendlyName: "EF Value Min",
          key: "EF_VALUE_MIN",
          column: "CV.EJECTION_FRACTION.EF_VALUE_MIN",
          not: false,
          dataType: "NUMBER",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.EJECTION_FRACTION.EF_VALUE_MIN";
              },
              friendlyName: "EF Min",
              operators: operators.number,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.EJECTION_FRACTION.EF_VALUE_MIN",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.EJECTION_FRACTION.DISPLAY_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: false,
              operator: ">=",
              operatorLabel: "greater than or equal to",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "NUMBER",
            },
          ],
        },
        {
          category: "Ejection Fraction",
          table: "EJECTION_FRACTION",
          fullTableName: "CV.EJECTION_FRACTION",
          friendlyName: "EF Value Max",
          key: "EF_VALUE_MAX",
          column: "CV.EJECTION_FRACTION.EF_VALUE_MAX",
          not: false,
          dataType: "NUMBER",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.EJECTION_FRACTION.EF_VALUE_MAX";
              },
              friendlyName: "EF Max",
              operators: operators.number,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.EJECTION_FRACTION.EF_VALUE_MAX",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.EJECTION_FRACTION.DISPLAY_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: false,
              operator: "<=",
              operatorLabel: "greater than or equal to",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "NUMBER",
            },
          ],
        },
        {
          category: "Ejection Fraction",
          table: "EJECTION_FRACTION",
          fullTableName: "CV.EJECTION_FRACTION",
          friendlyName: "Study Date",
          key: "STUDY_DATE",
          column: "CV.EJECTION_FRACTION.STUDY_DATE",
          not: false,
          dataType: "DATE",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.EJECTION_FRACTION.STUDY_DATE";
              },
              friendlyName: "Study Date",
              operators: operators.number,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.EJECTION_FRACTION.STUDY_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.EJECTION_FRACTION.DISPLAY_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: false,
              operator: "<=",
              operatorLabel: "greater than or equal to",
              valueSource: "value",
              value: null,
              any: false,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Lab Tests",
      icon: "TestTube",
      table: "LAB_RESULT",
      fullTableName: "CV.LAB_RESULTS",
      parentTable: "PATIENT",
      friendlyName: "Lab Test Name",
      key: "TEST_NAME",
      column: "CV.LAB_RESULTS.TEST_NAME",
      operator: "=",
      hasEndingLabel: true,
      endingLabelKey: "UOM",
      props: [],
      isChildFilterNumeric: false,
      columns: [
        {
          column: "CV.LAB_RESULTS.TEST_NAME",
          key: "TEST_NAME",
          friendlyName: "Lab Test Name",
        },
        {
          column: "CV.LAB_RESULTS.LOINC_TEST_CODE",
          key: "LOINC_TEST_CODE",
          friendlyName: "LOINC Test Code",
        },
        {
          column: "CV.LAB_RESULTS.UOM",
          key: "UOM",
          friendlyName: "Unit Of Measure",
        },
        {
          column: "CV.LAB_RESULTS.REFERENCE_RANGES",
          key: "REFERENCE_RANGES",
          friendlyName: "Reference Ranges",
        },
      ],
      enableTooltip: true,
      tooltip: {
        definition: definitions.labResult.definition,
        example: definitions.labResult.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.64453130566821",
          field: "CV.LAB_RESULTS.TEST_NAME",
          friendlyName: "Lab Observation",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "CV.LAB_RESULTS.TEST_NAME",
                },
                {
                  columnName: "CV.LAB_RESULTS.LOINC_TEST_CODE",
                },
                // {
                //   columnName: "CV.LAB_RESULTS.RESULT_TYPE"
                // },
                // {
                //   columnName: "CV.LAB_RESULTS.UOM"
                // },
                // {
                //   columnName: "CV.LAB_RESULTS.REFERENCE_RANGES"
                // },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Lab Result",
          table: "LAB_RESULT",
          fullTableName: "CV.LAB_RESULTS",
          parentTable: "PATIENT",
          friendlyName: "Unit of Measure",
          key: "UOM",
          column: "CV.LAB_RESULTS.UOM",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.LAB_RESULTS.UOM";
              },
              friendlyName: "Unit of Measure",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.LAB_RESULTS.UOM",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.LAB_RESULTS.TEST_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Lab Result",
          table: "LAB_RESULT",
          fullTableName: "CV.LAB_RESULTS",
          parentTable: "PATIENT",
          friendlyName: "Reference Ranges",
          key: "REFERENCE_RANGES",
          column: "CV.LAB_RESULTS.REFERENCE_RANGES",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.LAB_RESULTS.REFERENCE_RANGES";
              },
              friendlyName: "Reference Ranges",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.LAB_RESULTS.REFERENCE_RANGES",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.LAB_RESULTS.TEST_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Lab Result",
          table: "LAB_RESULT",
          fullTableName: "CV.LAB_RESULTS",
          parentTable: "PATIENT",
          friendlyName: "Lab Text Value",
          key: "OBSERVATION_VALUE_TEXT",
          column: "CV.LAB_RESULTS.OBSERVATION_VALUE_TEXT",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: "CV.LAB_RESULTS.OBSERVATION_VALUE_TEXT",
              friendlyName: "Lab Value",
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: false, //settings this to false, please see below
                  autoCompletePhrase: null, //this is set to null because otherwise it will search those 3 columns which we don't want
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.LAB_RESULTS.OBSERVATION_VALUE_TEXT",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.LAB_RESULTS.TEST_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataTypeColumn: "RESULT_TYPE",
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Lab Result",
          table: "LAB_RESULT",
          fullTableName: "CV.LAB_RESULTS",
          parentTable: "PATIENT",
          friendlyName: "Lab Numeric Value",
          key: "OBSERVATION_VALUE_NUMERIC",
          column: "CV.LAB_RESULTS.OBSERVATION_VALUE_NUMERIC",
          not: false,
          dataType: "NUMBER",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: "CV.LAB_RESULTS.OBSERVATION_VALUE_NUMERIC",
              friendlyName: "Lab Value",
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: false, //settings this to false, please see below
                  autoCompletePhrase: null, //this is set to null because otherwise it will search those 3 columns which we don't want
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.LAB_RESULTS.OBSERVATION_VALUE_NUMERIC",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.LAB_RESULTS.LOINC_TEST_CODE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataTypeColumn: "RESULT_TYPE",
              dataType: "NUMBER",
            },
          ],
        },
        // {
        //   id: "r-0.6445302420566821",
        //   field: (props) => {
        //     if (props && props.resultType === "T") {
        //       return "CV.LAB_RESULTS.OSERVATION_VALUE";
        //     }
        //     return "CV.LAB_RESULTS.OBSERVATION_VALUE";
        //   },
        //   friendlyName: "Lab Value",
        //   parentField:
        //     "CV.LAB_RESULTS.LOINC_TEST_CODE",
        //   distinctValueJSON: (columnValue, phrase = null) => {
        //     return {
        //       dbType,
        //       autoComplete: false, //settings this to false, please see below
        //       autoCompletePhrase: null, //this is set to null because otherwise it will search those 3 columns which we don't want
        //       limit: globalLimit,
        //       name: "getDistinctColumnValues",
        //       columnNames: [
        //         {
        //           columnName: "CV.LAB_RESULTS.OBSERVATION_VALUE",
        //         },
        //         {
        //           columnName: "CV.LAB_RESULTS.TEXT_VALUE",
        //         },
        //         {
        //           columnName: "CV.LAB_RESULTS.RESULT_TYPE",
        //         },
        //       ],
        //       wheres: {
        //         id: "g-0.8517528779532519",
        //         rules: [
        //           {
        //             id: "r-0.6445302420566821",
        //             field:
        //               "CV.LAB_RESULTS.LOINC_TEST_CODE",
        //             operator: "=",
        //             valueSource: "value",
        //             value: columnValue,
        //             dataType: "TEXT",
        //           },
        //         ],
        //         combinator: "and",
        //         not: false,
        //       },
        //     };
        //   },
        //   showOperator: true,
        //   operator: "=",
        //   operatorLabel: "is",
        //   valueSource: "value",
        //   value: null,
        //   selectOptions: [],
        //   displayType: null,
        //   rowCount: 0,
        //   selectOptionsColumn: (props) => {
        //     if (props && props.resultType === "T") return "TEXT_VALUE";
        //     return "OBSERVATION_VALUE";
        //   },
        //   any: false,
        //   dataTypeColumn: "RESULT_TYPE",
        //   dataType: (props) => {
        //     return props?.resultType === "N" ? "NUMBER" : "TEXT";
        //   },
        // },
      ],
    },
    // {
    //   category: "Lab Result",
    //   table: "LAB_RESULT",
    //   fullTableName: "CV.LAB_RESULTS",
    //   parentTable: "PATIENT",
    //   friendlyName: "Lab Observation",
    //   column: "CV.LAB_RESULTS.LOINC_TEST_CODE",
    //   translation: (arr, showOperator, category) => {
    //     if (!showOperator) {
    //       return `${category} with ${arr[0].friendlyName} of ${arr[0].value}`;
    //     }
    //     return `${category} where ${arr[0].friendlyName} ${arr[0].operatorLabel} ${arr[0].value}`;
    //   },
    //   queryBuilderJSON: [
    //     {
    //       id: "r-0.6445302420566821",
    //       field: (props) => {
    //         return "CV.LAB_RESULTS.LOINC_TEST_CODE";
    //       },
    //       friendlyName: "Lab Observation",
    //       operators: operators.text,
    //       distinctValueJSON: (columnValue, phrase = null) => {
    //         return {
    //           dbType,
    //           autoComplete: phrase ? true : false,
    //           autoCompletePhrase: phrase,
    //           limit: globalLimit,
    //           name: "getDistinctColumnValues",
    //           columnNames: [
    //             {
    //               columnName: "CV.LAB_RESULTS.LOINC_TEST_CODE",
    //             },
    //           ],
    //         };
    //       },
    //       showOperator: true,
    //       operator: "=",
    //       operatorLabel: "is",
    //       valueSource: "value",
    //       value: null,
    //       selectOptions: [],
    //       displayType: null,
    //       selectOptionsColumn: "LOINC_TEST_CODE",
    //       any: false,
    //       dataType: (props) => {
    //         return "TEXT";
    //       },
    //     },
    //   ],
    // },
    // {
    //   category: "Lab Result",
    //   friendlyName: "Unit of Measure",
    //   table: "LAB_RESULT",
    //   fullTableName: "CV.LAB_RESULTS",
    //   parentTable: "PATIENT",
    //   column: "CV.LAB_RESULTS.UOF_M",
    //   translation: (arr, showOperator, category) => {
    //     if (!showOperator) {
    //       return `${category} of type ${arr[0].value} between ${arr[1].value} and ${arr[2].value}`;
    //     }
    //     return `${category} of type ${arr[0].value} where ${arr[1].friendlyName} ${arr[1].operatorLabel} ${arr[1].value} and ${arr[2].friendlyName} ${arr[2].operatorLabel} ${arr[2].value}`;
    //   },
    //   queryBuilderJSON: [],
    // },
    // {
    //   category: "Lab Result",
    //   friendlyName: "Normal Range",
    //   table: "LAB_RESULT",
    //   fullTableName: "CV.LAB_RESULTS",
    //   parentTable: "PATIENT",
    //   column: "CV.LAB_RESULTS.NORMAL_RANGE",
    //   translation: (arr, showOperator, category) => {
    //     if (!showOperator) {
    //       return `${category} of type ${arr[0].value} between ${arr[1].value} and ${arr[2].value}`;
    //     }
    //     return `${category} of type ${arr[0].value} where ${arr[1].friendlyName} ${arr[1].operatorLabel} ${arr[1].value} and ${arr[2].friendlyName} ${arr[2].operatorLabel} ${arr[2].value}`;
    //   },
    //   queryBuilderJSON: [],
    // },
    {
      category: "Chief Complaint History",
      icon: "MessageSquare",
      table: "CHIEF_COMPLAINT_HISTORY",
      fullTableName: "CV.CHIEF_COMPLAINT_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Chief Complaint",
      key: "COMPLAINT",
      column: "CV.CHIEF_COMPLAINT_HISTORY.CHIEF_COMPLAINT",
      operator: "=",
      disabled: false,
      unstructured: true,
      enableTooltip: true,
      tooltip: {
        definition: definitions.chiefComplaint.definition,
        example: definitions.chiefComplaint.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "CV.CHIEF_COMPLAINT_HISTORY.CHIEF_COMPLAINT";
          },
          friendlyName: "Chief Complaint",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "CV.CHIEF_COMPLAINT_HISTORY.CHIEF_COMPLAINT",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Chief Complaint History",
          table: "CHIEF_COMPLAINT_HISTORY",
          fullTableName: "CV.CHIEF_COMPLAINT_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Encounter Date",
          key: "ENCOUNTER_DATE",
          column: "CV.CHIEF_COMPLAINT_HISTORY.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: (props) => {
                return "CV.CHIEF_COMPLAINT_HISTORY.ENCOUNTER_DATE";
              },
              friendlyName: "Reported Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.CHIEF_COMPLAINT_HISTORY.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.CHIEF_COMPLAINT_HISTORY.CHIEF_COMPLAINT",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Diagnosis History",
      icon: "FileText",
      table: "DIAGNOSIS_HISTORY",
      fullTableName: "CV.DIAGNOSIS_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Diagnosis Description",
      key: "ICD_DESCRIPTION",
      column: "CV.DIAGNOSIS_HISTORY.ICD_DESCRIPTION",
      operator: "=",
      enableTooltip: true,
      tooltip: {
        definition: definitions.diagnosisHistory.definition,
        example: definitions.diagnosisHistory.example,
      },
      columns: [
        {
          column: "CV.DIAGNOSIS_HISTORY.ICD_DESCRIPTION",
          key: "ICD_DESCRIPTION",
          friendlyName: "ICD Description",
          //showInFilter: false,
        },
        {
          column: "CV.DIAGNOSIS_HISTORY.PROBLEM_ICD",
          key: "PROBLEM_ICD",
          friendlyName: "ICD Code",
          //primary: true
        },
        {
          column: "CV.DIAGNOSIS_HISTORY.ICD_TYPE",
          key: "ICD_TYPE",
          friendlyName: "ICD Type",
          //showInFilter: false,
        }
      ],
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "CV.DIAGNOSIS_HISTORY.ICD_DESCRIPTION";
          },
          friendlyName: "ICD_DESCRIPTION",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "CV.DIAGNOSIS_HISTORY.ICD_DESCRIPTION",
                },
                {
                  columnName: "CV.DIAGNOSIS_HISTORY.PROBLEM_ICD",
                },
                {
                  columnName: "CV.DIAGNOSIS_HISTORY.ICD_TYPE",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Diagnosis History",
          table: "DIAGNOSIS_HISTORY",
          fullTableName: "CV.DIAGNOSIS_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "ICD Type",
          key: "ICD_TYPE",
          column: "CV.DIAGNOSIS_HISTORY.ICD_TYPE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.DIAGNOSIS_HISTORY.ICD_TYPE";
              },
              friendlyName: "ICD Type",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.DIAGNOSIS_HISTORY.ICD_TYPE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.DIAGNOSIS_HISTORY.ICD_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: null,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Diagnosis History",
          table: "DIAGNOSIS_HISTORY",
          fullTableName: "CV.DIAGNOSIS_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "ICD Code",
          key: "PROBLEM_ICD",
          column: "CV.DIAGNOSIS_HISTORY.PROBLEM_ICD",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.DIAGNOSIS_HISTORY.PROBLEM_ICD";
              },
              friendlyName: "ICD Code",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.DIAGNOSIS_HISTORY.PROBLEM_ICD",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.DIAGNOSIS_HISTORY.ICD_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: null,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Diagnosis History",
          table: "DIAGNOSIS_HISTORY",
          fullTableName: "CV.DIAGNOSIS_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "ICD Active",
          key: "ICD_ACTIVE",
          column: "CV.DIAGNOSIS_HISTORY.ICD_ACTIVE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.DIAGNOSIS_HISTORY.ICD_ACTIVE";
              },
              friendlyName: "ICD Active",
              operators: operators.text,

              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.DIAGNOSIS_HISTORY.ICD_ACTIVE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.DIAGNOSIS_HISTORY.ICD_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: "",
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "ICD_ACTIVE",
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Diagnosis History",
          table: "DIAGNOSIS_HISTORY",
          fullTableName: "CV.DIAGNOSIS_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Snomed",
          key: "SNOMED",
          column: "CV.DIAGNOSIS_HISTORY.SNOMED",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.DIAGNOSIS_HISTORY.SNOMED";
              },
              friendlyName: "Snowmed",
              operators: operators.text,

              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.DIAGNOSIS_HISTORY.SNOMED",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.DIAGNOSIS_HISTORY.ICD_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: "",
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "SNOMED",
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        // {
        //   category: "Diagnosis History",
        //   table: "DIAGNOSIS_HISTORY",
        //   fullTableName: "CV.DIAGNOSIS_HISTORY",
        //   parentTable: "PATIENT",
        //   friendlyName: "Reported Date",
        //   key: "REPORTED_DATE",
        //   column: "CV.DIAGNOSIS_HISTORY.REPORTED_DATE",
        //   not: false,
        //   dataType: "DATE",
        //   operator: ">",
        //   queryBuilderJSON: [
        //     {
        //       id: "r-0.6445302420566821",
        //       field: (props) => {
        //         return "CV.DIAGNOSIS_HISTORY.REPORTED_DATE";
        //       },
        //       friendlyName: "Reported Date",
        //       operators: operators.text,

        //       distinctValueJSON: (columnValue, phrase) => {
        //         return {
        //           dbType,
        //           autoComplete: phrase ? true : false,
        //           autoCompletePhrase: phrase,
        //           limit: globalLimit,
        //           name: "getDistinctColumnValues",
        //           columnNames: [
        //             {
        //               columnName:
        //                 "CV.DIAGNOSIS_HISTORY.REPORTED_DATE",
        //             },
        //           ],
        //           wheres: {
        //             id: "g-0.8517528779532519",
        //             rules: [
        //               {
        //                 id: "r-0.6445302420566821",
        //                 field:
        //                   "CV.DIAGNOSIS_HISTORY.ICD_DESCRIPTION",
        //                 operator: "=",
        //                 valueSource: "value",
        //                 value: columnValue,
        //                 dataType: "TEXT",
        //               },
        //             ],
        //             combinator: "and",
        //             not: false,
        //           },
        //         };
        //       },
        //       showOperator: true,
        //       operator: "=",
        //       operatorLabel: "is",
        //       valueSource: "value",
        //       value: "",
        //       selectOptions: [],
        //       displayType: null,
        //       rowCount: 0,
        //       selectOptionsColumn: "REPORTED_DATE",
        //       any: false,
        //       dataType: "DATE",
        //     },
        //   ]
        // },
        {
          category: "Diagnosis History",
          table: "DIAGNOSIS_HISTORY",
          fullTableName: "CV.DIAGNOSIS_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Diagnosis Date",
          key: "DATE_ACTIVE",
          column: "CV.DIAGNOSIS_HISTORY.DATE_ACTIVE",
          not: false,
          dataType: "DATE",
          operator: ">",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.DIAGNOSIS_HISTORY.DATE_ACTIVE";
              },
              friendlyName: "Diagnosis Date",
              operators: operators.text,

              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.DIAGNOSIS_HISTORY.DATE_ACTIVE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.DIAGNOSIS_HISTORY.ICD_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: "",
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "DATE_ACTIVE",
              any: false,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "DRM Data",
      table: "DRMDATA",
      fullTableName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA",
      parentTable: "PATIENT",
      friendlyName: "Report Name",
      key: "REPORT_NAME",
      column: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME";
          },
          friendlyName: "Report Name",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "DRM Data",
          table: "DRMDATA",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA",
          parentTable: "PATIENT",
          friendlyName: "Data Category",
          key: "DATA_CATEGORY",
          column: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.DATA_CATEGORY",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.DATA_CATEGORY";
              },
              friendlyName: "Report Name",
              operators: operators.text,
              parentField: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",

              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "DH_CRC_IUMED.IUMED_DBO_DRMDATA.DATA_CATEGORY",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "DATA_CATEGORY",
              any: null,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "DRM Data",
          table: "DRMDATA",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA",
          parentTable: "PATIENT",
          friendlyName: "Report Date",
          key: "REPORT_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_DATE";
              },
              friendlyName: "Report Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "DRM Data",
          table: "DRMDATA",
          fullTableName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA",
          parentTable: "PATIENT",
          friendlyName: "Study Date",
          key: "STUDY_DATE",
          column: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.STUDY_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: (props) => {
                return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.STUDY_DATE";
              },
              friendlyName: "Study Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.STUDY_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    // {
    //   category: "DRM Data",
    //   table: "DRMDATA",
    //   fullTableName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA",
    //   parentTable: "PATIENT",
    //   friendlyName: "Field Value",
    //   key: "FIELD_VALUE",
    //   column: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.FIELD_VALUE",
    //   translation: (arr, showOperator, category) => {
    //     if (!showOperator) {
    //       return `${category} with ${arr[0].friendlyName} of ${arr[0].value}`;
    //     }
    //     return `${category} where ${arr[0].friendlyName} ${arr[0].operatorLabel} ${arr[0].value}`;
    //   },
    //   queryBuilderJSON: [
    //     {
    //       id: "r-0.6445302420566821",
    //       field: (props) => {
    //         return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME";
    //       },
    //       friendlyName: "Report Name",
    //       operators: operators.text,
    //       distinctValueJSON: (columnValue, phrase = null) => {
    //         return {
    //           dbType,
    //           autoComplete: phrase ? true : false,
    //           autoCompletePhrase: phrase,
    //           limit: globalLimit,
    //           name: "getDistinctColumnValues",
    //           columnNames: [
    //             {
    //               columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
    //             }
    //           ],
    //         };
    //       },
    //       showOperator: true,
    //       operator: "=",
    //       operatorLabel: "is",
    //       valueSource: "value",
    //       value: null,
    //       selectOptions: [],
    //       displayType: null,
    //       rowCount: 0,
    //       any: null,
    //       dataType: (props) => {
    //         return "TEXT";
    //       },
    //     },
    //     {
    //       id: "r-0.6445302420566821",
    //       field: (props) => {
    //         return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.DATA_CATEGORY";
    //       },
    //       friendlyName: "Category",
    //       operators: operators.text,
    //       parentField: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
    //
    //       distinctValueJSON: (columnValue, phrase) => {
    //         return {
    //           dbType,
    //           autoComplete: phrase ? true : false,
    //           autoCompletePhrase: phrase,
    //           limit: globalLimit,
    //           name: "getDistinctColumnValues",
    //           columnNames: [
    //             {
    //               columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.DATA_CATEGORY",
    //             },
    //           ],
    //           wheres: {
    //             id: "g-0.8517528779532519",
    //             rules: [
    //               {
    //                 id: "r-0.6445302420566821",
    //                 field: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_NAME",
    //                 operator: "=",
    //                 valueSource: "value",
    //                 value: columnValue,
    //                 dataType: "TEXT",
    //               },
    //             ],
    //             combinator: "and",
    //             not: false,
    //           },
    //         };
    //       },
    //       showOperator: true,
    //       operator: "=",
    //       operatorLabel: "is",
    //       valueSource: "value",
    //       value: null,
    //       selectOptions: [],
    //       displayType: null,
    //       rowCount: 0,
    //       selectOptionsColumn: "DATA_CATEGORY",
    //       any: null,
    //       dataType: (props) => {
    //         return "TEXT";
    //       },
    //     },
    //     {
    //       id: "r-0.6445302420566821",
    //       field: (props) => {
    //         return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.FIELD_NAME";
    //       },
    //       friendlyName: "Field Name",
    //       operators: operators.text,
    //       parentField: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.DATA_CATEGORY",
    //
    //       distinctValueJSON: (columnValue, phrase) => {
    //         return {
    //           dbType,
    //           autoComplete: phrase ? true : false,
    //           autoCompletePhrase: phrase,
    //           limit: globalLimit,
    //           name: "getDistinctColumnValues",
    //           columnNames: [
    //             {
    //               columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.FIELD_NAME",
    //             },
    //           ],
    //           wheres: {
    //             id: "g-0.8517528779532519",
    //             rules: [
    //               {
    //                 id: "r-0.6445302420566821",
    //                 field: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.DATA_CATEGORY",
    //                 operator: "=",
    //                 valueSource: "value",
    //                 value: columnValue,
    //                 dataType: "TEXT",
    //               },
    //             ],
    //             combinator: "and",
    //             not: false,
    //           },
    //         };
    //       },
    //       showOperator: true,
    //       operator: "=",
    //       operatorLabel: "is",
    //       valueSource: "value",
    //       value: null,
    //       selectOptions: [],
    //       displayType: null,
    //       rowCount: 0,
    //       selectOptionsColumn: "FIELD_NAME",
    //       any: false,
    //       dataType: (props) => {
    //         return "TEXT";
    //       },
    //     },
    //     {
    //       id: "r-0.6445302420566551",
    //       field: (props) => {
    //         return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.STUDY_DATE";
    //       },
    //       friendlyName: "Study Date",
    //       operators: operators.date,
    //       distinctValueJSON: (columnValue, phrase = null) => {
    //         return {
    //           dbType,
    //           autoComplete: phrase ? true : false,
    //           autoCompletePhrase: phrase,
    //           limit: globalLimit,
    //           name: "getDistinctColumnValues",
    //           columnNames: [
    //             {
    //               columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.STUDY_DATE",
    //             }
    //           ],
    //         };
    //       },
    //       showOperator: true,
    //       operator: ">",
    //       operatorLabel: "greater than",
    //       valueSource: "value",
    //       value: null,
    //       dataType: (props) => {
    //         return "DATE";
    //       },
    //     },
    //     {
    //       id: "r-0.6445302420566551",
    //       field: (props) => {
    //         return "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_DATE";
    //       },
    //       friendlyName: "Report Date",
    //       operators: operators.date,
    //       distinctValueJSON: (columnValue, phrase = null) => {
    //         return {
    //           dbType,
    //           autoComplete: phrase ? true : false,
    //           autoCompletePhrase: phrase,
    //           limit: globalLimit,
    //           name: "getDistinctColumnValues",
    //           columnNames: [
    //             {
    //               columnName: "DH_CRC_IUMED.IUMED_DBO_DRMDATA.REPORT_DATE",
    //             }
    //           ],
    //         };
    //       },
    //       showOperator: true,
    //       operator: ">",
    //       operatorLabel: "greater than",
    //       valueSource: "value",
    //       value: null,
    //       dataType: (props) => {
    //         return "DATE";
    //       },
    //     },
    //   ],
    // },
    {
      category: "Family History",
      icon: "Home",
      table: "FAMILY_HISTORY",
      fullTableName: "CV.FAMILY_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Family History",
      key: "FAMILY_HISTORY",
      column: "CV.FAMILY_HISTORY.FAMILY_HISTORY",
      operator: "=",
      disabled: false,
      unstructured: true,
      enableTooltip: true,
      tooltip: {
        definition: definitions.familyHistory.definition,
        example: definitions.familyHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "CV.FAMILY_HISTORY.FAMILY_HISTORY";
          },
          friendlyName: "Family Member",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "CV.FAMILY_HISTORY.FAMILY_HISTORY",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        // {
        //   category: "Family History",
        //   table: "FAMILY_HISTORY",
        //   fullTableName: "CV.FAMILY_HISTORY",
        //   parentTable: "PATIENT",
        //   friendlyName: "Family Member Sex",
        //   key: "FAMILY_MEMBER_SEX",
        //   column: "CV.FAMILY_HISTORY.FAMILY_HISTORY_SEX",
        //   not: false,
        //   dataType: "TEXT",
        //   operator: "=",
        //   queryBuilderJSON: [
        //     {
        //       id: "r-0.6445302420566821",
        //       field: (props) => {
        //         return "CV.FAMILY_HISTORY.FAMILY_HISTORY_SEX";
        //       },
        //       friendlyName: "Family Member Sex",
        //       operators: operators.text,
        //       parentField: "CV.FAMILY_HISTORY.FAMILY_HISTORY",

        //       distinctValueJSON: (columnValue, phrase) => {
        //         return {
        //           dbType,
        //           autoComplete: phrase ? true : false,
        //           autoCompletePhrase: phrase,
        //           limit: globalLimit,
        //           name: "getDistinctColumnValues",
        //           columnNames: [
        //             {
        //               columnName:
        //                 "CV.FAMILY_HISTORY.FAMILY_HISTORY_SEX",
        //             },
        //           ],
        //           wheres: {
        //             id: "g-0.8517528779532519",
        //             rules: [
        //               {
        //                 id: "r-0.6445302420566821",
        //                 field:
        //                   "CV.FAMILY_HISTORY.FAMILY_HISTORY",
        //                 operator: "=",
        //                 valueSource: "value",
        //                 value: columnValue,
        //                 dataType: "TEXT",
        //               },
        //             ],
        //             combinator: "and",
        //             not: false,
        //           },
        //         };
        //       },
        //       showOperator: true,
        //       operator: "=",
        //       operatorLabel: "is",
        //       valueSource: "value",
        //       value: null,
        //       selectOptions: [],
        //       displayType: null,
        //       rowCount: 0,
        //       selectOptionsColumn: "FAMILY_MEMBER_SEX",
        //       any: false,
        //       dataType: "TEXT"
        //     }
        //   ]
        // },
        // {
        //   category: "Family History",
        //   table: "FAMILY_HISTORY",
        //   fullTableName: "CV.FAMILY_HISTORY",
        //   parentTable: "PATIENT",
        //   friendlyName: "Family History Problem",
        //   key: "FAMILY_HISTORY_PROBLEM",
        //   column: "CV.FAMILY_HISTORY.FAMILY_HISTORY_PROBLEM",
        //   not: false,
        //   dataType: "TEXT",
        //   operator: "=",
        //   queryBuilderJSON: [
        //     {
        //       id: "r-0.6445302420566821",
        //       field: (props) => {
        //         return "CV.FAMILY_HISTORY.FAMILY_HISTORY_PROBLEM";
        //       },
        //       friendlyName: "Family Member Sex",
        //       operators: operators.text,
        //       parentField: "CV.FAMILY_HISTORY.FAMILY_HISTORY_PROBLEM",

        //       distinctValueJSON: (columnValue, phrase) => {
        //         return {
        //           dbType,
        //           autoComplete: phrase ? true : false,
        //           autoCompletePhrase: phrase,
        //           limit: globalLimit,
        //           name: "getDistinctColumnValues",
        //           columnNames: [
        //             {
        //               columnName:
        //                 "CV.FAMILY_HISTORY.FAMILY_HISTORY_PROBLEM",
        //             },
        //           ],
        //           wheres: {
        //             id: "g-0.8517528779532519",
        //             rules: [
        //               {
        //                 id: "r-0.6445302420566821",
        //                 field:
        //                   "CV.FAMILY_HISTORY.FAMILY_HISTORY",
        //                 operator: "=",
        //                 valueSource: "value",
        //                 value: columnValue,
        //                 dataType: "TEXT",
        //               },
        //             ],
        //             combinator: "and",
        //             not: false,
        //           },
        //         };
        //       },
        //       showOperator: true,
        //       operator: "=",
        //       operatorLabel: "is",
        //       valueSource: "value",
        //       value: null,
        //       selectOptions: [],
        //       displayType: null,
        //       rowCount: 0,
        //       selectOptionsColumn: "FAMILY_MEMBER_SEX",
        //       any: false,
        //       dataType: "TEXT"
        //     }
        //   ]
        // },
        {
          category: "Family History",
          table: "FAMILY_HISTORY",
          fullTableName: "CV.FAMILY_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Encounter Date",
          key: "ENCOUNTER_DATE",
          column: "CV.FAMILY_HISTORY.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: (props) => {
                return "CV.FAMILY_HISTORY.ENCOUNTER_DATE";
              },
              friendlyName: "Entry Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.FAMILY_HISTORY.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.FAMILY_HISTORY.FAMILY_HISTORY",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Medication History",
      icon: "Pill",
      table: "MED_NAME",
      fullTableName: "CV.MEDICATION_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Medication Name",
      key: "MED_NAME",
      column: "CV.MEDICATION_HISTORY.MED_NAME",
      operator: "=",
      enableTooltip: true,
      tooltip: {
        definition: definitions.medicationHistory.definition,
        example: definitions.medicationHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "CV.MEDICATION_HISTORY.MED_NAME";
          },
          friendlyName: "Medication Name",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "CV.MEDICATION_HISTORY.MED_NAME",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          selectOptionsColumn: "MED_NAME",
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        // {
        //   category: "Medication History",
        //   table: "MEDICATION_HISTORY",
        //   fullTableName: "CV.MEDICATION_HISTORY",
        //   parentTable: "PATIENT",
        //   friendlyName: "Medication Code System",
        //   key: "MEDICATION_CODE_SYSTEM",
        //   column: "CV.MEDICATION_HISTORY.MEDICATION_CODE_SYSTEM",
        //   not: false,
        //   dataType: "TEXT",
        //   operator: "=",
        //   queryBuilderJSON: [
        //     {
        //       id: "r-0.6445302420566821",
        //       field: (props) => {
        //         return "CV.MEDICATION_HISTORY.MEDICATION_CODE_SYSTEM";
        //       },
        //       friendlyName: "Code System",
        //       operators: operators.text,
        //       distinctValueJSON: (columnValue, phrase = null) => {
        //         return {
        //           dbType,
        //           autoComplete: phrase ? true : false,
        //           autoCompletePhrase: phrase,
        //           limit: globalLimit,
        //           name: "getDistinctColumnValues",
        //           columnNames: [
        //             {
        //               columnName: "CV.MEDICATION_HISTORY.MEDICATION_CODE_SYSTEM",
        //             }
        //           ],
        //           wheres: {
        //             id: "g-0.8517528779532519",
        //             rules: [
        //               {
        //                 id: "r-0.6445302420566821",
        //                 field:
        //                   "CV.MEDICATION_HISTORY.MED_NAME",
        //                 operator: "=",
        //                 valueSource: "value",
        //                 value: columnValue,
        //                 dataType: "TEXT",
        //               },
        //             ],
        //             combinator: "and",
        //             not: false,
        //           },
        //         };
        //       },
        //       showOperator: true,
        //       operator: "=",
        //       operatorLabel: "is",
        //       valueSource: "value",
        //       value: null,
        //       selectOptions: [],
        //       displayType: null,
        //       rowCount: 0,
        //       any: false,
        //       dataType: "TEXT"
        //     }
        //   ],
        // },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "CV.MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Specialty",
          key: "SPECIALTY",
          column: "CV.MEDICATION_HISTORY.SPECIALTY",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.MEDICATION_HISTORY.SPECIALTY";
              },
              friendlyName: "Specialty",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.MEDICATION_HISTORY.SPECIALTY",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.MEDICATION_HISTORY.MED_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "CV.MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "RxNorm ID",
          key: "RXNORM_ID",
          column: "CV.MEDICATION_HISTORY.RXNORM_ID",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.MEDICATION_HISTORY.RXNORM_ID";
              },
              friendlyName: "Medication Code",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.MEDICATION_HISTORY.RXNORM_ID",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.MEDICATION_HISTORY.MED_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              selectOptionsColumn: "RXNORM_ID",
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "CV.MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Medication Strength",
          key: "STRENGTH",
          column: "CV.MEDICATION_HISTORY.STRENGTH",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.MEDICATION_HISTORY.STRENGTH";
              },
              friendlyName: "Medication Strength",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.MEDICATION_HISTORY.STRENGTH",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.MEDICATION_HISTORY.MED_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                  orderBys: [
                    {
                      column: "CV.MEDICATION_HISTORY.STRENGTH",
                      direction: "asc",
                    },
                  ],
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              selectOptionsColumn: "STRENGTH",
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "CV.MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Route Of Administration",
          key: "ROUTE",
          column: "CV.MEDICATION_HISTORY.ROUTE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.MEDICATION_HISTORY.ROUTE";
              },
              friendlyName: "Route of Administration",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.MEDICATION_HISTORY.ROUTE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.MEDICATION_HISTORY.MED_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "CV.MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Form",
          key: "DOSAGE_FORM",
          column: "CV.MEDICATION_HISTORY.DOSAGE_FORM",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.MEDICATION_HISTORY.DOSAGE_FORM";
              },
              friendlyName: "Form",
              operators: operators.text,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.MEDICATION_HISTORY.DOSAGE_FORM",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.MEDICATION_HISTORY.MED_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "is",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "CV.MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Not Active",
          key: "INACTIVE",
          column: "CV.MEDICATION_HISTORY.INACTIVE",
          not: false,
          dataType: "TEXT",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.MEDICATION_HISTORY.INACTIVE";
              },
              friendlyName: "Is Active",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.MEDICATION_HISTORY.INACTIVE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.MEDICATION_HISTORY.MED_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: false,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "TEXT",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "CV.MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Start Date",
          key: "DATE_INITIATED",
          column: "CV.MEDICATION_HISTORY.DATE_INITIATED",
          not: false,
          dataType: "DATE",
          operator: ">",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.MEDICATION_HISTORY.DATE_INITIATED";
              },
              friendlyName: "Start Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.MEDICATION_HISTORY.DATE_INITIATED",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.MEDICATION_HISTORY.MED_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "DATE",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">=",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
        {
          category: "Medication History",
          table: "MEDICATION_HISTORY",
          fullTableName: "CV.MEDICATION_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Stop Date",
          key: "DATE_INACTIVATED",
          column: 'CV.MEDICATION_HISTORY.DATE_INACTIVATED',
          not: false,
          dataType: "DATE",
          operator: ">",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.MEDICATION_HISTORY.DATE_INACTIVATED";
              },
              friendlyName: "Stop Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.MEDICATION_HISTORY.DATE_INACTIVATED",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.MEDICATION_HISTORY.MED_NAME",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "DATE",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "<=",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Past Medical History",
      icon: "Clock",
      table: "PAST_MEDICAL_HISTORY",
      fullTableName: "CV.PAST_MEDICAL_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Past Medical Answer",
      key: "PAST_MEDICAL_HISTORY",
      column: "CV.PAST_MEDICAL_HISTORY.PAST_MEDICAL_HISTORY",
      operator: "=",
      disabled: false,
      unstructured: true,
      enableTooltip: true,
      tooltip: {
        definition: definitions.pastMedicalHistory.definition,
        example: definitions.pastMedicalHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "CV.PAST_MEDICAL_HISTORY.PAST_MEDICAL_HISTORY";
          },
          friendlyName: "Question",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "CV.PAST_MEDICAL_HISTORY.PAST_MEDICAL_HISTORY",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Past Medical History",
          table: "PAST_MEDICAL_HISTORY",
          fullTableName: "CV.PAST_MEDICAL_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Entry Date",
          key: "ENCOUNTER_DATE",
          column: "CV.PAST_MEDICAL_HISTORY.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.PAST_MEDICAL_HISTORY.ENCOUNTER_DATE";
              },
              friendlyName: "Entry Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.PAST_MEDICAL_HISTORY.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.PAST_MEDICAL_HISTORY.PAST_MEDICAL_HISTORY",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Procedure History",
      icon: "Scissors",
      table: "PROCEDURE",
      fullTableName: "CV.PROCEDURE_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Procedure",
      key: "CPT_KEY",
      column: "CV.PROCEDURE_HISTORY.CPT_KEY",
      operator: "=",
      enableTooltip: true,
      tooltip: {
        definition: definitions.procedureHistory.definition,
        example: definitions.procedureHistory.example,
      },
      columns: [
        {
          column: "CV.PROCEDURE_HISTORY.CPT_KEY",
          key: "CPT_KEY",
          friendlyName: "CPT Key",
        },
        {
          column: "CV.PROCEDURE_HISTORY.CPT_DESCRIPTION",
          key: "CPT_DESCRIPTION",
          friendlyName: "CPT Description",
        },
      ],
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "CV.PROCEDURE_HISTORY.CPT_KEY";
          },
          friendlyName: "Procedure Description",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "CV.PROCEDURE_HISTORY.CPT_KEY",
                },
                {
                  columnName: "CV.PROCEDURE_HISTORY.CPT_DESCRIPTION",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          selectOptionsColumn: "PROCEDURE_DESCRIPTION",
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Procedure History",
          table: "PROCEDURE_HISTORY",
          fullTableName: "CV.PROCEDURE_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Procedure Date",
          key: "DATE_PERFORMED",
          column: "CV.PROCEDURE_HISTORY.DATE_PERFORMED",
          not: false,
          dataType: "DATE",
          operator: ">",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.PROCEDURE_HISTORY.DATE_PERFORMED";
              },
              friendlyName: "Procedure Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.PROCEDURE_HISTORY.DATE_PERFORMED",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.PROCEDURE_HISTORY.CPT_DESCRIPTION",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Review of System",
      icon: "CheckSquare",
      table: "REVIEW_OF_SYSTEM",
      fullTableName: "CV.REVIEW_OF_SYSTEMS_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Review of System Question",
      key: "REVIEW_OF_SYSTEMS",
      column: "CV.REVIEW_OF_SYSTEMS_HISTORY.REVIEW_OF_SYSTEMS",
      operator: "=",
      disabled: false,
      unstructured: true,
      enableTooltip: true,
      tooltip: {
        definition: definitions.reviewOfSystems.definition,
        example: definitions.reviewOfSystems.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "CV.REVIEW_OF_SYSTEMS_HISTORY.REVIEW_OF_SYSTEMS";
          },
          friendlyName: "Question",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "CV.REVIEW_OF_SYSTEMS_HISTORY.REVIEW_OF_SYSTEMS",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Review of System",
          table: "REVIEW_OF_SYSTEM",
          fullTableName: "CV.REVIEW_OF_SYSTEMS_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Entry Date",
          key: "ENCOUNTER_DATE",
          column: "CV.REVIEW_OF_SYSTEMS_HISTORY.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.REVIEW_OF_SYSTEMS_HISTORY.ENCOUNTER_DATE";
              },
              friendlyName: "Entry Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.REVIEW_OF_SYSTEMS_HISTORY.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.REVIEW_OF_SYSTEMS_HISTORY.REVIEW_OF_SYSTEMS",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Social History",
      icon: "Users",
      table: "SOCIAL_HISTORY",
      fullTableName: "CV.SOCIAL_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Social History Question",
      key: "SOCIAL_HISTORY",
      column: "CV.SOCIAL_HISTORY.SOCIAL_HISTORY",
      operator: "=",
      disabled: false,
      unstructured: true,
      enableTooltip: true,
      tooltip: {
        definition: definitions.socialHistory.definition,
        example: definitions.socialHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "CV.SOCIAL_HISTORY.SOCIAL_HISTORY";
          },
          friendlyName: "Question",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "CV.SOCIAL_HISTORY.SOCIAL_HISTORY",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Social History",
          table: "SOCIAL_HISTORY",
          fullTableName: "CV.SOCIAL_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Entry Date",
          key: "ENCOUNTER_DATE",
          column: "CV.SOCIAL_HISTORY.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: ">",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566821",
              field: (props) => {
                return "CV.SOCIAL_HISTORY.ENCOUNTER_DATE";
              },
              friendlyName: "Entry Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.SOCIAL_HISTORY.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.SOCIAL_HISTORY.SOCIAL_HISTORY",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: ">",
              operatorLabel: "greater than",
              valueSource: "value",
              value: null,
              selectOptions: [],
              displayType: null,
              rowCount: 0,
              any: false,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    // {
    //   category: "Stroke Risk Score",
    //   table: "STROKE_RISK_SCORE",
    //   fullTableName: "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE",
    //   parentTable: "PATIENT",
    //   friendlyName: "Stroke Risk Score",
    //   key: "RISK_PROGRAM",
    //   column: "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.RISK_PROGRAM",
    //   operator: "=",
    //   queryBuilderJSON: [
    //     {
    //       id: "r-0.6445302420566821",
    //       field: (props) => {
    //         return "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.RISK_PROGRAM";
    //       },
    //       friendlyName: "Risk Program",
    //       operators: operators.text,
    //       distinctValueJSON: (columnValue, phrase = null) => {
    //         return {
    //           dbType,
    //           autoComplete: phrase ? true : false,
    //           autoCompletePhrase: phrase,
    //           limit: globalLimit,
    //           name: "getDistinctColumnValues",
    //           columnNames: [
    //             {
    //               columnName: "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.RISK_PROGRAM",
    //             }
    //           ],
    //         };
    //       },
    //       showOperator: true,
    //       operator: "=",
    //       operatorLabel: "is",
    //       valueSource: "value",
    //       value: null,
    //       selectOptions: [],
    //       displayType: null,
    //       rowCount: 0,
    //       any: false,
    //       dataType: "TEXT"
    //     },
    //   ],
    //   childFilters: [
    //     {
    //       category: "Stroke Risk Score",
    //       table: "STROKE_RISK_SCORE",
    //       fullTableName: "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE",
    //       parentTable: "PATIENT",
    //       friendlyName: "Risk Score",
    //       key: "RISK_SCORE",
    //       column: "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.RISK_SCORE",
    //       not: false,
    //       dataType: "TEXT",
    //       operator: "=",
    //       queryBuilderJSON: [
    //         {
    //           id: "r-0.6445302420566821",
    //           field: (props) => {
    //             return "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.RISK_SCORE";
    //           },
    //           friendlyName: "Score",
    //           operators: operators.date,
    //           distinctValueJSON: (columnValue, phrase = null) => {
    //             return {
    //               dbType,
    //               autoComplete: phrase ? true : false,
    //               autoCompletePhrase: phrase,
    //               limit: globalLimit,
    //               name: "getDistinctColumnValues",
    //               columnNames: [
    //                 {
    //                   columnName: "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.RISK_SCORE",
    //                 }
    //               ],
    //               wheres: {
    //                 id: "g-0.8517528779532519",
    //                 rules: [
    //                   {
    //                     id: "r-0.6445302420566821",
    //                     field:
    //                       "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.RISK_PROGRAM",
    //                     operator: "=",
    //                     valueSource: "value",
    //                     value: columnValue,
    //                     dataType: "TEXT",
    //                   },
    //                 ],
    //                 combinator: "and",
    //                 not: false,
    //               },
    //             };
    //           },
    //           showOperator: true,
    //           operator: ">",
    //           operatorLabel: "greater than",
    //           valueSource: "value",
    //           value: null,
    //           selectOptions: [],
    //           displayType: null,
    //           rowCount: 0,
    //           any: false,
    //           dataType: "TEXT"
    //         }
    //       ],
    //     },
    //     {
    //       category: "Stroke Risk Score",
    //       table: "STROKE_RISK_SCORE",
    //       fullTableName: "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE",
    //       parentTable: "PATIENT",
    //       friendlyName: "Entry Date",
    //       key: "SCORE_DATE",
    //       column: "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.SCORE_DATE",
    //       not: false,
    //       dataType: "DATE",
    //       operator: ">",
    //       queryBuilderJSON: [
    //         {
    //           id: "r-0.6445302420566821",
    //           field: (props) => {
    //             return "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.SCORE_DATE";
    //           },
    //           friendlyName: "Score Date",
    //           operators: operators.date,
    //           distinctValueJSON: (columnValue, phrase = null) => {
    //             return {
    //               dbType,
    //               autoComplete: phrase ? true : false,
    //               autoCompletePhrase: phrase,
    //               limit: globalLimit,
    //               name: "getDistinctColumnValues",
    //               columnNames: [
    //                 {
    //                   columnName: "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.SCORE_DATE",
    //                 }
    //               ],
    //               wheres: {
    //                 id: "g-0.8517528779532519",
    //                 rules: [
    //                   {
    //                     id: "r-0.6445302420566821",
    //                     field:
    //                       "DH_CRC_IUMED.IUMED_DBO_STROKE_RISK_SCORE.RISK_PROGRAM",
    //                     operator: "=",
    //                     valueSource: "value",
    //                     value: columnValue,
    //                     dataType: "TEXT",
    //                   },
    //                 ],
    //                 combinator: "and",
    //                 not: false,
    //               },
    //             };
    //           },
    //           showOperator: true,
    //           operator: ">",
    //           operatorLabel: "greater than",
    //           valueSource: "value",
    //           value: null,
    //           selectOptions: [],
    //           displayType: null,
    //           rowCount: 0,
    //           any: false,
    //           dataType: "DATE"
    //         }
    //       ],
    //     },
    //   ]
    // },
    {
      category: "Vital Sign History",
      icon: "Activity",
      table: "VITAL_SIGN_HISTORY",
      fullTableName: "CV.VITAL_SIGN_HISTORY",
      parentTable: "PATIENT",
      friendlyName: "Vital Sign Description",
      key: "VITAL",
      column: "CV.VITAL_SIGN_HISTORY.VITAL",
      operator: "=",
      hasEndingLabel: false,
      //endingLabelKey: 'UNIT_OF_MEASURE',
      hiddenColumns: {
        VITAL: true,
        PATIENTCOUNT: true,
      },
      enableTooltip: true,
      tooltip: {
        definition: definitions.vitalSignHistory.definition,
        example: definitions.vitalSignHistory.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "CV.VITAL_SIGN_HISTORY.VITAL";
          },
          friendlyName: "Vital Sign Description",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "CV.VITAL_SIGN_HISTORY.VITAL",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Vital Sign History",
          table: "VITAL_SIGN_HISTORY",
          fullTableName: "CV.VITAL_SIGN_HISTORY",
          parentTable: "PATIENT",
          friendlyName: "Vital Sign Value",
          key: "VALUE",
          column: "CV.VITAL_SIGN_HISTORY.VALUE",
          not: false,
          dataType: "NUMBER",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: "CV.VITAL_SIGN_HISTORY.VALUE",
              friendlyName: "Vital Sign Value",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.VITAL_SIGN_HISTORY.VALUE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.VITAL_SIGN_HISTORY.VITAL",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "TEXT",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "equal",
              valueSource: "value",
              value: null,
              dataType: "NUMBER",
            },
          ],
        },
      ],
    },
    {
      category: "Assessment",
      icon: "Target",
      table: "ASSESSMENT",
      fullTableName: "CV.ASSESSMENT",
      parentTable: "PATIENT",
      friendlyName: "Assessment",
      key: "ASSESSMENT",
      column: "CV.ASSESSMENT.ASSESSMENT",
      operator: "=",
      hasEndingLabel: false,
      enableTooltip: true,
      tooltip: {
        definition: definitions.assessment.definition,
        example: definitions.assessment.example,
      },
      disabled: false,
      unstructured: true,
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "CV.ASSESSMENT.ASSESSMENT";
          },
          friendlyName: "Assessment",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "CV.ASSESSMENT.ASSESSMENT",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Assessment",
          table: "ASSESSMENT",
          fullTableName: "CV.ASSESSMENT",
          parentTable: "PATIENT",
          friendlyName: "Encounter Date",
          key: "VALUE",
          column: "CV.ASSESSMENT.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: "CV.ASSESSMENT.ENCOUNTER_DATE",
              friendlyName: "Encounter Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.ASSESSMENT.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.ASSESSMENT.ENCOUNTER_DATE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "DATE",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "equal",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "History of Present Illness",
      icon: "ClipboardList",
      table: "HISTORY_OF_PRESENT_ILLNESS",
      fullTableName: "CV.HISTORY_OF_PRESENT_ILLNESS",
      parentTable: "PATIENT",
      friendlyName: "Vital Sign Description",
      key: "HISTORY_OF_PRESENT_ILLNESS",
      column: "CV.HISTORY_OF_PRESENT_ILLNESS.HISTORY_OF_PRESENT_ILLNESS",
      operator: "=",
      hasEndingLabel: false,
      enableTooltip: true,
      tooltip: {
        definition: definitions.historyOfPresentIllness.definition,
        example: definitions.historyOfPresentIllness.example,
      },
      disabled: false,
      unstructured: true,
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "CV.HISTORY_OF_PRESENT_ILLNESS.HISTORY_OF_PRESENT_ILLNESS";
          },
          friendlyName: "Vital Sign Description",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName:
                    "CV.HISTORY_OF_PRESENT_ILLNESS.HISTORY_OF_PRESENT_ILLNESS",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "History of Present Illness",
          table: "HISTORY_OF_PRESENT_ILLNESS",
          fullTableName: "CV.HISTORY_OF_PRESENT_ILLNESS",
          parentTable: "PATIENT",
          friendlyName: "Encounter Date",
          key: "VALUE",
          column: "CV.HISTORY_OF_PRESENT_ILLNESS.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: "CV.HISTORY_OF_PRESENT_ILLNESS.ENCOUNTER_DATE",
              friendlyName: "Encounter Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName:
                        "CV.HISTORY_OF_PRESENT_ILLNESS.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.HISTORY_OF_PRESENT_ILLNESS.ENCOUNTER_DATE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "DATE",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "equal",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Physical Exam",
      icon: "Stethoscope",
      table: "PHYSICAL_EXAM",
      fullTableName: "CV.PHYSICAL_EXAM",
      parentTable: "PATIENT",
      friendlyName: "PHYSICAL_EXAM",
      key: "PHYSICAL_EXAM",
      column: "CV.PHYSICAL_EXAM.PHYSICAL_EXAM",
      operator: "=",
      hasEndingLabel: false,
      enableTooltip: true,
      tooltip: {
        definition: definitions.physicalExam.definition,
        example: definitions.physicalExam.example,
      },
      disabled: false,
      unstructured: true,
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "CV.PHYSICAL_EXAM.PHYSICAL_EXAM";
          },
          friendlyName: "Phyiscal Exam",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "CV.PHYSICAL_EXAM.PHYSICAL_EXAM",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Physical Exam",
          table: "PHYSICAL_EXAM",
          fullTableName: "CV.PHYSICAL_EXAM",
          parentTable: "PATIENT",
          friendlyName: "Encounter Date",
          key: "VALUE",
          column: "CV.PHYSICAL_EXAM.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: "CV.PHYSICAL_EXAM.ENCOUNTER_DATE",
              friendlyName: "Encounter Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.PHYSICAL_EXAM.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.PHYSICAL_EXAM.ENCOUNTER_DATE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "DATE",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "equal",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Plan",
      icon: "Calendar",
      table: "PLAN",
      fullTableName: "CV.PLAN",
      parentTable: "PATIENT",
      friendlyName: "Plan",
      key: "PLAN",
      column: "CV.PLAN.PLAN",
      operator: "=",
      hasEndingLabel: false,
      disabled: false,
      unstructured: true,
      enableTooltip: true,
      tooltip: {
        definition: definitions.plan.definition,
        example: definitions.plan.example,
      },
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "CV.PLAN.PLAN";
          },
          friendlyName: "Plan",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "CV.PLAN.PLAN",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [
        {
          category: "Plan",
          table: "PLAN",
          fullTableName: "CV.PLAN",
          parentTable: "PATIENT",
          friendlyName: "Encounter Date",
          key: "VALUE",
          column: "CV.PLAN.ENCOUNTER_DATE",
          not: false,
          dataType: "DATE",
          operator: "=",
          queryBuilderJSON: [
            {
              id: "r-0.6445302420566551",
              field: "CV.PLAN.ENCOUNTER_DATE",
              friendlyName: "Encounter Date",
              operators: operators.date,
              distinctValueJSON: (columnValue, phrase = null) => {
                return {
                  dbType,
                  autoComplete: phrase ? true : false,
                  autoCompletePhrase: phrase,
                  limit: globalLimit,
                  name: "getDistinctColumnValues",
                  columnNames: [
                    {
                      columnName: "CV.PLAN.ENCOUNTER_DATE",
                    },
                  ],
                  wheres: {
                    id: "g-0.8517528779532519",
                    rules: [
                      {
                        id: "r-0.6445302420566821",
                        field: "CV.PLAN.ENCOUNTER_DATE",
                        operator: "=",
                        valueSource: "value",
                        value: columnValue,
                        dataType: "DATE",
                      },
                    ],
                    combinator: "and",
                    not: false,
                  },
                };
              },
              showOperator: true,
              operator: "=",
              operatorLabel: "equal",
              valueSource: "value",
              value: null,
              dataType: "DATE",
            },
          ],
        },
      ],
    },
    {
      category: "Documents",
      icon: "NotepadText",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "Documents",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
    {
      category: "CRC CHF Registry",
      icon: "HeartCrack",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "CRC CHF Registry",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
    {
      category: "CRC AFIB Registry",
      icon: "HeartPulse",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "CRC AFIB Registry",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
    {
      category: "CRC PCI Registry",
      icon: "Syringe",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "CRC PCI Registry",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
    {
      category: "CRC MI Registry",
      icon: "HeartCrack",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "CRC MI Registry",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
    {
      category: "CRC EP Registry",
      icon: "Activity",
      table: "",
      fullTableName: "",
      parentTable: "PATIENT",
      friendlyName: "CRC EP Registry",
      key: "",
      column: "",
      operator: "=",
      visible: false,
      disabled: true,
      enableTooltip: false,
      queryBuilderJSON: [],
      childFilters: [],
    },
    {
      category: "Payor",
      icon: "CreditCard",
      table: "PATIENT_PAYOR",
      fullTableName: "CV.PATIENT_PAYOR",
      parentTable: "PATIENT",
      friendlyName: "Payor",
      key: "PAYOR",
      column: "CV.PATIENT_PAYOR.INSURANCE_TYPE",
      operator: "=",
      hasEndingLabel: false,
      disabled: false,
      unstructured: false,
      enableTooltip: false,
      tooltip: {
        definition: "",
        example: "",
      },
      queryBuilderJSON: [
        {
          id: "r-0.64453024205443822",
          field: (props) => {
            return "CV.PATIENT_PAYOR.INSURANCE_TYPE";
          },
          friendlyName: "Payor",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType,
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "CV.PATIENT_PAYOR.INSURANCE_TYPE",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: null,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
  ],
};

export default data;
